export default __webpack_public_path__ + "static/img/homepage-bg-selection.7ea2477.jpg";